export { default as EventDetailTemplate } from './EventDetailTemplate';
